<template>
  <div class="menu-check">
    <div class="head-right">
                  <button type="button" v-on:click="back" class="btn btn-third btn-sm ml-3"  style="margin-top: 13px; height:30.4px;width:27.4"  v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonBack"><i class="fas fa-arrow-circle-left"></i></button>
                  <h4 class="head-title-rg" style="margin-top: 15px;margin-left: 7px">Detalhe Supervisão - {{codigo}}</h4>
                  <div class="ml-auto d-flex" style="gap: 1rem; justify-content: center; align-items: center; margin-right: 1rem;">
                    <div class="btnNotAprovacao" v-if="dataCheckForm.statusvistoria != 2" v-on:click="$emit('AdicionarObs')" v-b-tooltip.hover :title="'Reprovar vistoria'"><i class="fa fa-minus-circle" style="color: white; font-size: 15px;"></i></div>
                    <div class="buttonAprovar" v-if="dataCheckForm.statusvistoria != 3" v-on:click="$emit('openAprovedVistoria')" v-b-tooltip.hover :title="'Aprovar vistoria'"><img class="mr-1" src="https://static.zopone.com.br/img/survey/IconeSim.svg" ></div>
                  </div>
              </div>
      <div class="bodyall">
       <div class="bodyallimg">
            <div  class="cardCheck mb-2"  v-for="obj in Enum" v-on:click="showModal(obj)"  v-bind:key="obj.Value" >
          <div class="Icone">
            <img cls v-if="testeCheck(obj.value) == false" src="https://static.zopone.com.br/img/survey/Icone_Conforme.svg">
            <img cls v-if="testeCheck(obj.value) == true" src="https://static.zopone.com.br/img/survey/Icone_NãoConforme.svg">
          </div>
          <div class="cardbody-s  mt-5">
            <h1 class="statusFont text-center mt-4" :class="testeCheck(obj.value)  == true ? 'cardNotConform' : 'cardConform'">{{testeCheck(obj.value) == true ? 'Não conforme' : 'Conforme'}}</h1>
            <p class="text-center titleCheck">{{obj.text | filterEnum   }}</p>
            <div class="footerFor">
              <div class="flexfooter ">
                  <i class="fas fa-eye mt-2 mr-1"></i>
                <h4 class="FontFooter mt-2">Detalhes</h4>
              </div>
            </div>
          </div>
    </div>
       </div>
    <div class="mt-5"></div>
      </div>
     <b-modal :header-bg-variant="this.statusModalCheck == true ? '' :  'danger'"  ref="modal-checklist" hide-footer :title="'Checklist de Supervisão'">
       <div class="card headTitle">
        <h1 class="titleModal" >{{titleModal | filterEnum}}</h1>
       </div>
      <div class="modalbody">
         <div v-for="obj in dataModal" v-bind:key="obj.id">
         <div style="display:flex">
           <img class="mr-2" v-if="Chekarlista(obj.id)" src="https://static.zopone.com.br/img/survey/Icone_NãoConforme.svg">
           <img class="mr-2" v-if="Chekarlista(obj.id) == false" src="https://static.zopone.com.br/img/survey/Icone_Conforme.svg">
            <h1 class="desc">{{ obj.descricao }}</h1>
         </div>
         <hr>
       </div>
      </div>
        <div class="d-flex justify-content-center">
        <!-- <button v-on:click="setConform" class="btn-Con mt-1 mr-1">CONFORME</button>
        <button v-on:click="setFalseNotConform" class="btn-Notcon mt-1  mr-1">NÃO CONFORME</button> -->
   </div>
   <!-- <div class="d-flex justify-content-center mt-3">
        <button v-on:click="setFalseNotConform" class="btn btn-success mr-1">SALVAR</button>
   </div> -->
  </b-modal>
  </div>
</template>
<script>
import checklisttableComponent from '@/views/private/Survey/components/checklist/checklisttable.js'
export default checklisttableComponent
</script>

<style>
.btnNotAprovacao{
  margin-top: 0px;
  width: 40px;
  height: 40px;
  cursor: pointer;
  border: none;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #b72121 0% 0% no-repeat padding-box;
  outline: none;
}
.btnNotpdf{
  margin-top: 0px;
  width: 40px;
  height: 40px;
  cursor: pointer;
  border: none;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #c9c9c9 0% 0% no-repeat padding-box;
  outline: none;
}
.buttonAprovar{
  margin-top: 0px;
  cursor: pointer;
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #008148 0% 0% no-repeat padding-box;
  outline: none;
}
.buttonAprovar:hover{
  background: rgb(7, 161, 72);
}
.cardCheck{
  margin-left: 13px;
  height: 150px;
  position: relative;
  cursor: pointer;
  width: 304px;
  display: inline-block
}

.statusicon{
  background-color: white;
  height: 35px;
  width: 35px;
  border-radius: 50%;
}

.btn-Con, .btn-Notcon{
  background: #B4B4B4;
  border: 1px;
  color: white;
  width: 100px;
  height: 50px;
  border-radius: 4px;
}
.modalbody{
  height: 300px;
  overflow-y: auto;
}
.FontFooter{
  font-size: 16px;
  color: #4F4C4D;
}
.cardbody-s{
  background: #F6F6F6 0% 0% no-repeat padding-box;
  border: 1px solid #D1D1D1;
  border-radius: 4px;
}
.footerFor{
  background-color: #E4E5E6;
  height:  40px;
  margin-bottom: 0px;
}
.menu-check{
  border: 1px solid #CFD8DC;
  border-radius: 4px;
  height: 100%;
  overflow-y: auto;
}

.statusFont{
  color: white;
  margin-top: 5px;
  margin-left: 20px;
  font-size: 25px;
  font-weight: bold;
}
.titleCheck{
  text-align: left;
  font-size: 16px;
  margin-left: 20px;
  letter-spacing: 0px;
  color: #4F4C4D;
  opacity: 1;
}

.Icone{
  position: absolute;
  margin-left: 135px;
  margin-top: 25px;
}
.btn-Con:hover{
  background: green;
}
.btn-Notcon:hover{
  background-color: #E4E5E6 ;
}
.cardChechHead{
  background: #F6F6F6 0% 0% no-repeat padding-box;
  height: 35%;
}
.statusCheck{
  border-bottom: 2px;
  color: white;
}
.flexfooter{
  display: flex;
  margin-left: 115px;
  color: black;
}

.inputCheck:focus{
  outline: none;
  border: none;
}
.warn{
  font-size: 20px;
  margin-top: 5px;
  margin-bottom: 5px;
  text-align: center;
  color: red;
}

.headTitle{
  width: 100%;
  text-align: center;
}
.titleModal{
  margin-top: 20px;
  font-size: 25px;
  font-weight: bold;
}
.desc{
  margin-top: 13px;
  font-size: 15px;
}
.btn-footer{
  width: 100%;
  height: 100%;
  background: #E4E5E6 0% 0% no-repeat padding-box;
  color: black;
  border: none;
}
.footer{
  margin-left : auto;
  width: 100%;
  color: #4F4C4D;
  background: #E4E5E6 0% 0% no-repeat padding-box;
  font-size: 12px;
}
.footerLi{
  font-size: 16px;
  letter-spacing: 0.18px;
  color: #4F4C4D;
  opacity: 1;
  margin-bottom: 100px;
}
.body{
  text-align: left;
font: normal normal 600 16px/22px;
letter-spacing: 0px;

color: #4F4C4D;
}

.bodyall{
  margin-left: 10px;
  margin-right: 10px;
  height: 100%;
  overflow: hidden;
}
.cardNotConform{
  color: red;
}
.cardConform{
  color: green;
}

@media (max-width:1518px) {
  .bodyallimg{
    margin-left: 50px;
  }
  .cardCheck {
    margin-left: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/private/Survey/components/checklist/checklisttable.vue